import React from 'react'
import { useTranslation } from 'react-i18next'

import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { FormGroup } from '@mui/material'
import Typography from '@mui/material/Typography'

import { GraphSeriesConfig } from '../../types/graphSeriesConfig'
import { BasicDataParam, GraphDataParamString, GraphDataParam } from '../../types/enums/graphDataParam'

interface CompareCheckboxGroupProps {
  seriesConfig: Array<GraphSeriesConfig>
  checkedCompareParams: Array<GraphDataParam>
  onChange: (param: GraphDataParam) => void
  row: boolean
}

const CompareCheckboxGroup = (props: CompareCheckboxGroupProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <FormGroup row={props.row}>
      {props.seriesConfig
        .filter((x) => x.param !== BasicDataParam.CRACK)
        .map((config: GraphSeriesConfig) => {
          return (
            <FormControlLabel
              sx={{ ml: props.row ? 1 : 0 }}
              key={config.param}
              control={
                <Checkbox
                  size="small"
                  checked={props.checkedCompareParams.indexOf(config.param) > -1}
                  onChange={() => props.onChange(config.param)}
                  name={config.param}
                />
              }
              label={
                <Typography
                  variant={props.row ? undefined : 'caption'}
                  sx={{ lineHeight: 1, borderBottom: `2px solid ${config.color}` }}
                >
                  {t(GraphDataParamString[config.param]) || config.seriesLabel}
                </Typography>
              }
            />
          )
        })}
    </FormGroup>
  )
}

export default CompareCheckboxGroup
